// @flow
import React from 'react'
import Row from './Row'
import Ref from 'components/References/Ref'
import formatters from 'lib/formatters'
import styles from './styles'

type Props = {
  closing_fee_data: ?{
    date: string,
    amount: number,
  },
}

const ClosingFeeRef = (props: Props) => {
  const { closing_fee_data } = props

  return (
    <Ref
      title="Closing Fee"
      preview={
        <div>
          {!closing_fee_data ? (
            <Row singleLine label="Not taken" val="" mono={true} />
          ) : (
            <>
              <Row singleLine label="Date" val={formatters.date(closing_fee_data.date)} mono={true} />
              <Row singleLine label="Amount" val={formatters.money(closing_fee_data.amount)} mono={true} />
            </>
          )}
        </div>
      }
    />
  )
}

export default ClosingFeeRef
